import gql from 'graphql-tag'

export const QUBIT_QUERY = gql`
  query PlacementContent(
    $mode: Mode!
    $placementId: String!
    $attributes: Attributes!
    $resolveVisitorState: Boolean!
    $recsPreFilter: Boolean!
    $skuList: [String]
  ) {
    qubitPlacements(
      mode: $mode
      placementId: $placementId
      attributes: $attributes
      resolveVisitorState: $resolveVisitorState
      recsPreFilter: $recsPreFilter
      skuList: $skuList
    ) @client(always: true) {
      content
      callbackData
      visitorId
    }
  }
`
